import React from "react";

function Icon({ className = null, seasonColor, id = "" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="200"
      height="280"
      viewBox="0 0 200 280"
      preserveAspectRatio="none"
      className={className}
    >
      <defs>
        <clipPath id={`${id}-clip-path-6`}>
          <path
            fill="#fff"
            d="M0 0H200V280H0z"
            data-name="Rectangle 1795"
            transform="translate(-9236 -11193)"
          ></path>
        </clipPath>
      </defs>
      <g
        clipPath={`url(#${id}-clip-path-6)`}
        data-name="Groupe de masques 61"
        transform="translate(9236 11193)"
      >
        <g data-name="Groupe 11590" transform="translate(-9347.203 -11294.236)">
          <path
            fill="#06ae5c"
            d="M0 135.582v17.9C84.64 153.48 154.191 86.137 162.168 0 68.73 16.191 0 70.758 0 135.582"
            data-name="Tracé 2661"
            transform="translate(199.193 278.993)"
          ></path>
          <path
            fill="#996b59"
            d="M0 135.582v17.9C84.64 153.48 154.191 86.137 162.168 0 68.73 16.191 0 70.758 0 135.582"
            data-name="Tracé 2662"
            transform="translate(2.679 49.176)"
          ></path>
          <path
            fill="#e0c6a2"
            d="M0 135.582v17.9C84.64 153.48 154.191 86.137 162.168 0 68.73 16.191 0 70.758 0 135.582"
            data-name="Tracé 2663"
            transform="translate(167.501)"
          ></path>
          <path
            fill={seasonColor}
            d="M0 135.582v17.9C84.64 153.48 154.191 86.137 162.168 0 68.73 16.191 0 70.758 0 135.582"
            data-name="Tracé 2664"
            transform="translate(34.371 327.537)"
          ></path>
        </g>
      </g>
    </svg>
  );
}

export default Icon;
